export var RemoteStatus;
(function (RemoteStatus) {
    RemoteStatus["Unloaded"] = "UNLOADED";
    RemoteStatus["Loading"] = "LOADING";
    RemoteStatus["Loaded"] = "LOADED";
    RemoteStatus["Failed"] = "FAILED";
})(RemoteStatus || (RemoteStatus = {}));
export function isLoading(remote) {
    if (Array.isArray(remote))
        return remote.some(function (_a) {
            var status = _a.status;
            return status === RemoteStatus.Loading;
        });
    return remote.status === RemoteStatus.Loading;
}
//# sourceMappingURL=Remote.js.map